import * as React from "react";

export type OnDisplayProps = {
    text?: string;
    link: string;
    linkText: string;
    size?: "small" | "large";
};

export const OnDisplay = ({ text, link, linkText, size = "large" }: OnDisplayProps) => {
    return (
        <a href={link} className={`OnDisplay ${size === "small" ? "OnDisplay--small" : "OnDisplay--large"}`}>
            <span className="OnDisplay__icon" aria-hidden="true">
                M
            </span>
            <span>
                {text} <span>{linkText}</span>
            </span>
        </a>
    );
};
